import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	makeStyles,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Typography,
} from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { useQuery, useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: 500,
	},
}));

const InvoiceDialog = ({ userPayment, onClose }) => {
	const classes = useStyles();
	const translate = useTranslate();
	const handleClose = () => onClose();
	const { data, loading } = useQuery({
		type: "get",
		resource: `user-payments/invoice/${get(userPayment, "id")}`,
		payload: {},
	});

	if (loading) {
		return null;
	}

	const stats = get(data, "data.stats");
	var formatter = new Intl.NumberFormat("it-IT", {
		style: "currency",
		currency: "EUR",
		useGrouping: true,
	});
	const range = moment(
		`${get(userPayment, "year")}-${get(userPayment, "month")}-01`
	);
	return (
		<Dialog open={userPayment !== null}>
			<DialogTitle>
				<Typography style={{ fontWeight: "bold" }}>
					{translate(`resources.user-payments.name`, 1)}
				</Typography>
				<Typography variant="subtitle1" component="span">
					{range.format("MMMM YYYY")}
				</Typography>
			</DialogTitle>
			<DialogContent className={classes.root}>
				<Table>
					<TableBody>
						{stats.map((stat, i) => (
							<TableRow key={i}>
								<TableCell>
									<Typography style={{ fontWeight: "bold" }}>
										{get(stat, "quantity", 0) > 0 && get(stat, "quantity")}
										{translate(
											`resources.events.code.${get(stat, "event_name")}`,
											get(stat, "data")
										)}
									</Typography>
									{stat.description !== null && (
										<Typography color="textSecondary" variant="caption">
											{stat.description}
										</Typography>
									)}
								</TableCell>
								<TableCell>{formatter.format(get(stat, "amount"))}</TableCell>
							</TableRow>
						))}
						{get(userPayment, "adjustements", []).length > 0 && (
							<>
								{userPayment.adjustements.map((a) => (
									<TableRow key={a.id}>
										<TableCell>
											<Typography style={{ fontWeight: "bold" }}>
												{translate(
													"resources.user-payment-adjustements.fields.amount"
												)}
											</Typography>
											{a.description !== null && (
												<Typography color="textSecondary" variant="caption">
													{a.description}
												</Typography>
											)}
										</TableCell>
										<TableCell>{formatter.format(a.amount)}</TableCell>
									</TableRow>
								))}
							</>
						)}
						<TableRow>
							<TableCell>
								<Typography style={{ fontWeight: "bold" }}>
									{translate("resources.user-payments.fields.amount")}
								</Typography>
							</TableCell>
							<TableCell>
								{formatter.format(get(userPayment, "amount"))}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>{translate("ra.action.close")}</Button>
			</DialogActions>
		</Dialog>
	);
};
InvoiceDialog.propTypes = {
	id: PropTypes.number,
	userPayment: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired,
};
export default InvoiceDialog;
